export const translations = {
  en: {
    nav: {
      how: "How it works",
      love: "Why Telefonka",
      phones: "Phones",
      packages: "Packages",
      gallery: "Gallery",
      team: "About us",
      faq: "FAQ",
      cta: "Order now",
    },
    hero: {
      eyebrow: "Retro telephone guestbook",
      title: "More than a memory",
      titleAccent: "the voices of your loved ones",
      subtitle: "A retro telephone guestbook for weddings and special events.",
      primary: "Order now",
      secondary: "How it works",
      tag1: "Simple to use",
      tag2: "No internet needed",
      tag3: "Digital recordings",
      badgeKicker: "Beep…",
      badgeText: "Leave a voice message",
      phoneAria: "Open the Telefonka booking form",
    },
    how: {
      kicker: "How it works",
      title: "Simple, comfortable and quick",
      labels: { guest: "guest", couple: "couple" },
      steps: [
        {
          n: "01",
          title: "Pick up the handset",
          body: "The guest lifts the handset. Telefonka is ready and waiting at the venue.",
          audience: "guest",
        },
        {
          n: "02",
          title: "Listen to the welcome",
          body: "A welcome message recorded by the couple greets the guest.",
          audience: "guest",
        },
        {
          n: "03",
          title: "After the beep, it is your turn… :)",
          body: "Share a wish, a story, a laugh or even a heartfelt confession.",
          audience: "guest",
        },
        {
          n: "04",
          title: "Receive every message",
          body: "After the event, we deliver every recording digitally so it can stay with you forever.",
          audience: "couple",
        },
      ],
    },
    love: {
      kicker: "Why people love it",
      title: "Hear the messages people might never have said out loud.",
      whyTitle: "Why Telefonka?",
      whyBody: "Because Telefonka is an experience, a decoration and a lasting memory at the same time.",
      items: [
        "More personal than a written guestbook.",
        "Funny, touching and spontaneous messages are born.",
        "It looks elegant as part of the decoration.",
        "Easy to use for every generation.",
        "A digital memory you can keep forever.",
      ],
    },
    products: {
      kicker: "The Telefonkas",
      title: "Choose the phone that fits your event",
      sub: "Pick the Telefonka that best matches the mood and style of your celebration.",
      cta: "Order now",
      items: [
        {
          name: "White audio Telefonka",
          selection: "White audio Telefonka",
          description: "A bright, elegant retro phone for personal voice messages.",
          features: [
            "Retro telephone voice recording",
            "Light and elegant appearance",
            "Ideal for weddings and minimal decoration",
          ],
        },
        {
          name: "Video Telefonka",
          selection: "Video Telefonka",
          description: "A visual guestbook for recording video messages.",
          features: [
            "Records video messages",
            "Available in multiple colour variations",
            "Brown and black-and-white versions",
          ],
        },
      ],
    },
    cards: {
      kicker: "Telefonka cards",
      title: "A little help for the first sentence",
      body: "Telefonka cards give guests an idea when they are not sure how to start their message.",
      cta: "Add to my order",
      features: [
        "5 complimentary Telefonka cards",
        "A pack of 25 questions",
        "25 additional questions as a gift",
        "Personalised Telefonka cards",
      ],
    },
    extras: {
      kicker: "Extra services",
      title: "Make the memory truly yours",
      cta: "Add to my order",
      items: [
        {
          name: "USB drive delivery",
          description: "Your finished recordings can also be delivered on a USB drive upon request.",
        },
        {
          name: "Audio prepared for videos",
          description: "We can prepare audio that is easy to use in wedding films, social videos or anniversary montages.",
          highlight: "Let your favourite moments speak again",
        },
      ],
    },
    packages: {
      kicker: "Packages and prices",
      title: "Choose what fits your event",
      sub: "The final price is confirmed based on the selected Telefonka, date and optional extras.",
      price: "Custom quote",
      cta: "Order now",
      tiers: [
        {
          name: "Basic package",
          tagline: "The essentials for a personal audio guestbook",
          features: [
            "Retro telephone guestbook",
            "Standard welcome message",
            "Digital delivery of voice recordings",
          ],
        },
        {
          name: "Wedding package",
          tagline: "Designed to blend into your wedding decoration",
          features: [
            "Wedding-ready presentation",
            "Personalised welcome message",
            "Organised digital delivery",
          ],
        },
        {
          name: "Premium package",
          tagline: "A fully prepared, elevated experience",
          features: [
            "Complete preparation",
            "Premium appearance",
            "Enhanced post-production and delivery",
          ],
        },
      ],
    },
    gallery: {
      kicker: "Gallery",
      title: "Telefonka moments",
      sub: "Real event photos are coming soon. Every placeholder can be replaced easily.",
      labels: [
        "White audio Telefonka",
        "Wedding decoration",
        "Guestbook atmosphere",
        "Reception detail",
        "Telefonka cards",
        "Behind the scenes",
      ],
      close: "Close image",
    },
    video: {
      kicker: "See it in action",
      title: "This is how Telefonka comes to life",
      body: "See how guests use Telefonka and how easily personal memories are created.",
      placeholder: "The presentation video is coming soon.",
    },
    testimonials: {
      kicker: "What you said",
      title: "Real words from real events",
      empty: "Verified customer reviews will appear here after the first events.",
    },
    team: {
      kicker: "About us",
      title: "Meet the team",
      sub: "The people working behind Telefonka.",
      members: [
        { name: "Anna", role: "" },
        { name: "Gellért", role: "" },
        { name: "Csabi", role: "Background operations and marketing" },
      ],
    },
    faq: {
      kicker: "Frequently asked questions",
      title: "Good to know",
      sub: "The most important details, briefly, to make your decision easier.",
      items: [
        {
          q: "How does ordering work?",
          a: "Choose a Telefonka or package, enter the date and key details of your event, then send your order request. We confirm availability and agree on the details and welcome message.",
        },
        {
          q: "How do we receive the voice messages?",
          a: "After the event, we deliver every recorded message digitally as clearly organised files.",
        },
        {
          q: "Does it need internet?",
          a: "No. Telefonka does not need an internet connection at the venue.",
        },
        {
          q: "Does Telefonka need a power cable during use?",
          a: "No. Telefonka does not require a continuous mains connection while in use.",
        },
        {
          q: "How easy is it to use?",
          a: "Very easy: the guest picks up the handset, listens to the welcome and speaks after the beep.",
        },
        {
          q: "Can it be rented for other events?",
          a: "Yes. It is also a great choice for birthdays, anniversaries, corporate events and family celebrations.",
        },
        {
          q: "What happens after the event?",
          a: "We collect and check the recordings, then deliver them digitally in the format included in your order.",
        },
      ],
    },
    closing: {
      title: "Would you keep the voices of your loved ones?",
      body: "Order Telefonka and collect messages that will still be a joy to hear years from now.",
      cta: "Order now",
      contact: "Questions? Get in touch with us with confidence.",
    },
    contact: {
      name: "Full name",
      email: "Email address",
      phone: "Phone number",
      date: "Event date",
      location: "Event location",
      eventType: "Event type",
      eventTypePlaceholder: "Select an event type",
      eventTypes: ["Wedding", "Birthday", "Anniversary", "Corporate event", "Family celebration", "Other"],
      pkg: "Selected package",
      pkgPlaceholder: "Choose a package",
      pkgOptions: ["Basic package", "Wedding package", "Premium package", "Not sure yet"],
      message: "Notes about your event",
    },
    booking: {
      kicker: "Order Telefonka",
      title: "Choose your date and Telefonka",
      sub: "Select your event date and we will show only the phones still available.",
      pickDate: "Event date",
      checking: "Checking availability…",
      available: "Available Telefonkas",
      selected: "Selected",
      availableLabel: "Available",
      noneAvailable: "Sorry, this date is already fully booked.",
      pickDateFirst: "Choose your event date to see available phones.",
      formTitle: "Your details",
      extrasTitle: "Extra services",
      consent: "I accept that my data will be processed for handling my order request.",
      preferredPhone: "Preferred Telefonka",
      submit: "Send order request",
      submitting: "Sending…",
      successTitle: "Order request received",
      successBody: "Thank you! We received your request and will confirm availability shortly.",
      makeAnother: "New order",
      mustPickPhone: "Please select an available Telefonka.",
      mustFill: "Please enter your name and email address.",
      mustConsent: "Please accept the data processing statement.",
      conflict: "This Telefonka was just booked by someone else. Please choose another.",
      genericError: "Something went wrong. Please try again.",
      extraOptions: ["USB drive delivery", "Audio prepared for videos", "Personalised Telefonka cards"],
    },
    footer: {
      tagline: "More than a memory — the voices of your loved ones.",
      rights: "All rights reserved.",
    },
  },

  hu: {
    nav: {
      how: "Hogyan működik?",
      love: "Miért a Telefonka?",
      phones: "Telefonkák",
      packages: "Árak",
      gallery: "Galéria",
      team: "Rólunk",
      faq: "Gyakori kérdések",
      cta: "Megrendelem",
    },
    hero: {
      eyebrow: "Retró telefonos vendégkönyv",
      title: "Több mint emlék",
      titleAccent: "a szeretteid hangjai",
      subtitle: "Retró telefonos vendégkönyv esküvőkre és különleges eseményekre.",
      primary: "Megrendelem",
      secondary: "Hogyan működik?",
      tag1: "Egyszerű használat",
      tag2: "Internet nélkül",
      tag3: "Digitális felvételek",
      badgeKicker: "Sípszó…",
      badgeText: "Hagyj egy hangüzenetet",
      phoneAria: "Ugrás a Telefonka megrendeléséhez",
    },
    how: {
      kicker: "Hogyan működik?",
      title: "Egyszerű, kényelmes, gyors",
      labels: { guest: "vendég", couple: "pár" },
      steps: [
        {
          n: "01",
          title: "Emeld fel a kagylót",
          body: "A vendég felemeli a kagylót. A telefon készen várja a vendégeket a helyszínen.",
          audience: "guest",
        },
        {
          n: "02",
          title: "Hallgasd meg a köszöntőnket",
          body: "A pár által előre felvett üdvözlő szöveg köszönti a vendéget.",
          audience: "guest",
        },
        {
          n: "03",
          title: "A sípszó után ti jöttök… :)",
          body: "Jöhet a jókívánság, sztori, nevetés vagy megható vallomás.",
          audience: "guest",
        },
        {
          n: "04",
          title: "Megkapjátok az üzeneteket, amelyek örökre veletek maradnak",
          body: "Az esemény után digitálisan adjuk át az összes hangüzenetet.",
          audience: "couple",
        },
      ],
    },
    love: {
      kicker: "Miért szeretik?",
      title: "Olyan üzeneteket hallhatsz, amiket talán sosem mondtak volna el.",
      whyTitle: "Miért a Telefonka?",
      whyBody: "Mert a Telefonka egyszerre program, dekoráció és maradandó emlék.",
      items: [
        "Személyesebb, mint az írott vendégkönyv.",
        "Vicces, megható és spontán üzenetek születnek.",
        "Dekorációként is elegánsan mutat.",
        "Minden korosztály számára könnyen használható.",
        "Digitálisan megőrizhető emléket ad.",
      ],
    },
    products: {
      kicker: "A Telefonkák",
      title: "Válaszd ki az eseményedhez illő Telefonkát",
      sub: "Találd meg az eseményed hangulatához és stílusához legjobban illő készüléket.",
      cta: "Megrendelem",
      items: [
        {
          name: "Fehér audió Telefonka",
          selection: "Fehér audió Telefonka",
          description: "Világos, elegáns retró telefon személyes hangüzenetek rögzítéséhez.",
          features: [
            "Retró telefonos hangrögzítés",
            "Világos, elegáns megjelenés",
            "Esküvőkhöz és letisztult dekorációkhoz ajánlott",
          ],
        },
        {
          name: "Videós Telefonka",
          selection: "Videós Telefonka",
          description: "Vizuális vendégkönyv személyes videóüzenetek rögzítéséhez.",
          features: [
            "Videóüzenetek rögzítésére alkalmas",
            "Többféle színváltozat",
            "Barna és fekete-fehér változat",
          ],
        },
      ],
    },
    cards: {
      kicker: "Telefonkártyák",
      title: "Egy kis segítség az első mondathoz",
      body: "A Telefonkártyák ötletet adnak azoknak a vendégeknek, akik nem tudják, mivel kezdjék az üzenetüket.",
      cta: "Hozzáadom a megrendeléshez",
      features: [
        "5 darab ajándék Telefonkártya",
        "25 kérdésből álló kártyacsomag",
        "25 további kérdés ajándékba",
        "Személyre szabható Telefonkártyák",
      ],
    },
    extras: {
      kicker: "Extra szolgáltatások",
      title: "Tedd igazán személyessé az emléket",
      cta: "Hozzáadom a megrendeléshez",
      items: [
        {
          name: "Pendrive-os átadás",
          description: "Az elkészült hanganyagok kérésre pendrive-on is átadhatók.",
        },
        {
          name: "Videókhoz előkészített hanganyag",
          description: "Kérésre olyan hanganyagot készítünk, amely könnyen felhasználható esküvői videókban, közösségi médiás összeállításokban vagy évfordulós montázsokban.",
          highlight: "A kedvenc pillanataitok újra megszólalhatnak",
        },
      ],
    },
    packages: {
      kicker: "Csomagok és árak",
      title: "Válassz az eseményedhez illő csomagot",
      sub: "A pontos árat a kiválasztott Telefonka, időpont és extra szolgáltatások alapján erősítjük meg.",
      price: "Ajánlat alapján",
      cta: "Megrendelem",
      tiers: [
        {
          name: "Alap csomag",
          tagline: "A személyes hangos vendégkönyv legfontosabb elemei",
          features: [
            "Retró telefonos vendégkönyv",
            "Alap üdvözlő szöveg",
            "Digitálisan átadott hangfelvételek",
          ],
        },
        {
          name: "Esküvői csomag",
          tagline: "Az esküvői dekorációhoz és hangulathoz igazítva",
          features: [
            "Esküvői dekorációhoz illő megjelenés",
            "Személyre szabott köszöntő",
            "Rendezett digitális átadás",
          ],
        },
        {
          name: "Prémium csomag",
          tagline: "Teljes körűen előkészített, kiemelt élmény",
          features: [
            "Teljes körű előkészítés",
            "Prémium megjelenés",
            "Kiemelt utómunka és átadás",
          ],
        },
      ],
    },
    gallery: {
      kicker: "Galéria",
      title: "Telefonkás pillanatok",
      sub: "A valódi eseményfotók hamarosan érkeznek. Minden helyőrző egyszerűen cserélhető.",
      labels: [
        "Fehér audió Telefonka",
        "Esküvői dekoráció",
        "Vendégkönyv-hangulat",
        "Részlet a helyszínről",
        "Telefonkártyák",
        "Kulisszák mögött",
      ],
      close: "Kép bezárása",
    },
    video: {
      kicker: "Nézd meg működés közben",
      title: "Így kel életre a Telefonka",
      body: "Nézd meg, hogyan használják a vendégek a Telefonkát, és milyen egyszerűen születnek belőle személyes emlékek.",
      placeholder: "A bemutatóvideó hamarosan érkezik.",
    },
    testimonials: {
      kicker: "Ti mondtátok",
      title: "Valódi visszajelzések valódi eseményekről",
      empty: "Az első események után itt jelennek meg az ellenőrzött vásárlói értékelések.",
    },
    team: {
      kicker: "Rólunk",
      title: "Találkozz a csapattal",
      sub: "Akik a Telefonka mögött dolgoznak.",
      members: [
        { name: "Anna", role: "" },
        { name: "Gellért", role: "" },
        { name: "Csabi", role: "Háttérfolyamatok és marketing" },
      ],
    },
    faq: {
      kicker: "Gyakori kérdések",
      title: "Jó tudni",
      sub: "A legfontosabb tudnivalók röviden, hogy könnyű legyen dönteni.",
      items: [
        {
          q: "Mi a rendelés menete?",
          a: "Válaszd ki a megfelelő Telefonkát vagy csomagot, add meg az esemény időpontját és legfontosabb adatait, majd küldd el a megrendelést. Ezután visszaigazoljuk az elérhetőséget, egyeztetjük a részleteket és az üdvözlő üzenetet.",
        },
        {
          q: "Hogyan kapjuk meg a hangüzeneteket?",
          a: "Az esemény után digitális formában adjuk át az összes rögzített üzenetet, átláthatóan rendezett fájlokként.",
        },
        {
          q: "Kell internet a használathoz?",
          a: "Nem. A Telefonka helyszíni használatához nincs szükség internetkapcsolatra.",
        },
        {
          q: "Kell tápkábel a Telefonka használatához?",
          a: "Nem. A Telefonka használat közben nem igényel folyamatos hálózati csatlakozást.",
        },
        {
          q: "Mennyire egyszerű használni?",
          a: "Nagyon egyszerű: a vendég felemeli a kagylót, meghallgatja az üdvözlést, majd a sípszó után elmondja az üzenetét.",
        },
        {
          q: "Más eseményre is bérelhető?",
          a: "Igen. A Telefonka születésnapra, évfordulóra, céges rendezvényre és családi ünnepre is remek választás.",
        },
        {
          q: "Mi történik az esemény után?",
          a: "Begyűjtjük és ellenőrizzük a felvételeket, majd a megrendelés szerinti formában digitálisan átadjuk nektek.",
        },
      ],
    },
    closing: {
      title: "Megőriznétek a szeretteitek hangját?",
      body: "Rendeljétek meg a Telefonkát, és gyűjtsetek olyan üzeneteket, amelyeket évek múlva is öröm lesz visszahallgatni.",
      cta: "Megrendelem",
      contact: "Ha bármi kérdésetek van, forduljatok hozzánk bizalommal!",
    },
    contact: {
      name: "Teljes név",
      email: "E-mail-cím",
      phone: "Telefonszám",
      date: "Esemény dátuma",
      location: "Esemény helyszíne",
      eventType: "Esemény típusa",
      eventTypePlaceholder: "Válassz eseménytípust",
      eventTypes: ["Esküvő", "Születésnap", "Évforduló", "Céges rendezvény", "Családi ünnep", "Egyéb"],
      pkg: "Választott csomag",
      pkgPlaceholder: "Válassz csomagot",
      pkgOptions: ["Alap csomag", "Esküvői csomag", "Prémium csomag", "Még nem tudom"],
      message: "Megjegyzés az eseményről",
    },
    booking: {
      kicker: "Telefonka megrendelése",
      title: "Válassz időpontot és Telefonkát",
      sub: "Válaszd ki az esemény dátumát, és csak az aznap elérhető Telefonkák jelennek meg.",
      pickDate: "Esemény dátuma",
      checking: "Elérhetőség ellenőrzése…",
      available: "Elérhető Telefonkák",
      selected: "Kiválasztva",
      availableLabel: "Elérhető",
      noneAvailable: "Sajnáljuk, ez a dátum már teljesen foglalt.",
      pickDateFirst: "Válaszd ki az esemény dátumát, hogy lásd az elérhető Telefonkákat.",
      formTitle: "Adataitok",
      extrasTitle: "Extra szolgáltatások",
      consent: "Hozzájárulok, hogy az adataimat a megrendelési igény kezelése céljából feldolgozzák.",
      preferredPhone: "Kiválasztott Telefonka",
      submit: "Megrendelési igény elküldése",
      submitting: "Küldés…",
      successTitle: "A megrendelési igény beérkezett",
      successBody: "Köszönjük! Megkaptuk a kéréseteket, és hamarosan visszaigazoljuk az elérhetőséget.",
      makeAnother: "Új megrendelés",
      mustPickPhone: "Kérjük, válasszatok egy elérhető Telefonkát.",
      mustFill: "Kérjük, adjátok meg a neveteket és az e-mail-címeteket.",
      mustConsent: "Kérjük, fogadjátok el az adatkezelési hozzájárulást.",
      conflict: "Ezt a Telefonkát az imént valaki más lefoglalta. Válasszatok másikat.",
      genericError: "Valami hiba történt. Próbáljátok újra.",
      extraOptions: ["Pendrive-os átadás", "Videókhoz előkészített hanganyag", "Személyre szabott Telefonkártyák"],
    },
    footer: {
      tagline: "Több mint emlék – a szeretteid hangjai.",
      rights: "Minden jog fenntartva.",
    },
  },
};